import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";

import { cn } from "../../lib/utils";
import { Field, FieldShell } from "./field";

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  description?: ReactNode;
  endAdornment?: ReactNode;
  error?: ReactNode;
  label?: ReactNode;
  startAdornment?: ReactNode;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  {
    className,
    description,
    endAdornment,
    error,
    id,
    label,
    startAdornment,
    ...props
  },
  ref,
) {
  return (
    <Field
      description={description}
      error={error}
      htmlFor={id}
      label={label}
      required={props.required}
    >
      <FieldShell hasError={!!error}>
        {startAdornment ? (
          <span className="text-muted-foreground">{startAdornment}</span>
        ) : null}
        <input
          ref={ref}
          className={cn(
            "min-h-11 flex-1 bg-transparent text-sm outline-none placeholder:text-muted-foreground",
            className,
          )}
          data-slot="interactive-control"
          id={id}
          {...props}
        />
        {endAdornment ? (
          <span className="text-muted-foreground">{endAdornment}</span>
        ) : null}
      </FieldShell>
    </Field>
  );
});
